import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "p-fluid formgrid grid" }
const _hoisted_2 = { class: "field col-12 lg:col-5" }
const _hoisted_3 = { class: "field col-12 lg:col-2" }
const _hoisted_4 = { class: "field col-12 lg:col-3" }
const _hoisted_5 = { class: "field col-12 lg:col-2 text-right" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { style: {"display":"block"} }, " ", -1)
const _hoisted_7 = {
  key: 0,
  class: "col-12"
}
const _hoisted_8 = {
  key: 1,
  class: "field col-12 text-right"
}
const _hoisted_9 = {
  key: 2,
  class: "col-12"
}
const _hoisted_10 = {
  key: 0,
  class: "badge status-green"
}
const _hoisted_11 = {
  key: 1,
  class: "badge status-red"
}
const _hoisted_12 = {
  key: 2,
  class: "badge status-purple"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.handleSubmit()), ["prevent"])),
    onKeydown: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleKeydown($event)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("label", null, _toDisplayString(_ctx.t("statHandleCode.company")), 1),
        _createVNode(_component_Dropdown, {
          modelValue: _ctx.companyId,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.companyId) = $event)),
          options: _ctx.companies,
          onChange: _ctx.dataChanged,
          optionLabel: "name",
          optionValue: "id",
          placeholder: "-"
        }, null, 8, ["modelValue", "options", "onChange"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("label", null, _toDisplayString(_ctx.t("statHandleCode.itemCode")), 1),
        _createVNode(_component_InputText, {
          modelValue: _ctx.itemCode,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.itemCode) = $event)),
          type: "text",
          onChange: _ctx.dataChanged
        }, null, 8, ["modelValue", "onChange"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("label", null, _toDisplayString(_ctx.t("statHandleCode.period")), 1),
        _createVNode(_component_Calendar, {
          manualInput: false,
          minDate: new Date('01/01/2022'),
          maxDate: new Date(),
          selectionMode: "range",
          showIcon: true,
          modelValue: _ctx.period,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.period) = $event)),
          yearRange: '2022:2100',
          onDateSelect: _ctx.dataChanged
        }, null, 8, ["minDate", "maxDate", "modelValue", "onDateSelect"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode(_component_Button, {
          label: _ctx.t('buttons.search'),
          icon: "pi pi-search",
          type: "submit",
          class: "p-button-primary p-uppercase"
        }, null, 8, ["label"])
      ]),
      (_ctx.showResults)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_component_Divider)
          ]))
        : _createCommentVNode("", true),
      (_ctx.showResults && _ctx.results.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(_component_Button, {
              label: _ctx.t('buttons.print'),
              icon: "pi pi-print",
              class: "p-button-primary p-uppercase",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.printReport()))
            }, null, 8, ["label"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.showResults)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createVNode(_component_DataTable, {
              dataKey: "id",
              responsiveLayout: "scroll",
              showGridlines: "",
              sortField: "code",
              sortOrder: 1,
              stripedRows: "",
              value: _ctx.results
            }, {
              empty: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t("gen.noData")), 1)
              ]),
              loading: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t("gen.loading")), 1)
              ]),
              footer: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(_ctx.t("statHandleCode.handleCodeCount")) + ": " + _toDisplayString(_ctx.n(_ctx.handleCodeCount, "number0")), 1)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_Column, {
                  field: "type",
                  header: _ctx.t('statHandleCode.parcel'),
                  headerStyle: "width: 15%"
                }, {
                  body: _withCtx(({ data, field }) => [
                    _createTextVNode(_toDisplayString(data[field] ? `${data[field].name} ${data["code"]}` : `${_ctx.t("statHandleCode.parcel")} ${data["code"]}`), 1)
                  ]),
                  _: 1
                }, 8, ["header"]),
                _createVNode(_component_Column, {
                  field: "inboundShipment",
                  sortField: "inboundShipment.date",
                  header: _ctx.t('statHandleCode.inboundShipment'),
                  sortable: "",
                  headerStyle: "width: 25%"
                }, {
                  body: _withCtx(({ data, field }) => [
                    _createTextVNode(_toDisplayString(data[field]
                  ? _ctx.t("statHandleCode.shipmentDetail", {
                      code: data[field].code,
                      date: _ctx.d(data[field].date, "shortDate"),
                      companyName: data[field].company.name,
                    })
                  : "-"), 1)
                  ]),
                  _: 1
                }, 8, ["header"]),
                _createVNode(_component_Column, {
                  field: "outboundShipment",
                  sortField: "outboundShipment.date",
                  header: _ctx.t('statHandleCode.outboundShipment'),
                  sortable: "",
                  headerStyle: "width: 25%"
                }, {
                  body: _withCtx(({ data, field }) => [
                    _createTextVNode(_toDisplayString(data[field]
                  ? _ctx.t("statHandleCode.shipmentDetail", {
                      code: data[field].code,
                      date: _ctx.d(data[field].date, "shortDate"),
                      companyName: data[field].company.name,
                    })
                  : "-"), 1)
                  ]),
                  _: 1
                }, 8, ["header"]),
                _createVNode(_component_Column, {
                  field: "action",
                  header: _ctx.t('statHandleCode.action'),
                  bodyClass: "text-center",
                  headerStyle: "width: 20%"
                }, {
                  body: _withCtx(({ data, field }) => [
                    (data[field].action == 'created')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.t("statHandleCode.parcelStates.created")), 1))
                      : (data[field].action == 'sent')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.t("statHandleCode.parcelStates.sent")), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.t("statHandleCode.parcelStates.unknown")), 1))
                  ]),
                  _: 1
                }, 8, ["header"]),
                _createVNode(_component_Column, {
                  field: "quantity",
                  header: _ctx.t('statHandleCode.quantity'),
                  bodyClass: "text-right",
                  headerStyle: "width: 15%"
                }, {
                  body: _withCtx(({ data, field }) => [
                    _createTextVNode(_toDisplayString(data[field] ? _ctx.n(data[field], "number0") : "0"), 1)
                  ]),
                  _: 1
                }, 8, ["header"])
              ]),
              _: 1
            }, 8, ["value"])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 32))
}